import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Users } from 'lucide-react';

const VITALIS_LOGO = "https://vitalis-sports.ch/wp-content/uploads/2024/10/Asset-3.png";

export default function UeberUns() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <div className="bg-[#1e3a5f] text-white py-1.5 px-4 text-xs">
        <div className="max-w-7xl mx-auto flex items-center justify-end gap-3">
          <span className="text-white/70">Mitarbeiter-Bereich</span>
          <Link to="/login" className="flex items-center gap-1.5 bg-orange-500 hover:bg-orange-600 px-3 py-1 rounded text-xs font-medium">
            <Users className="h-3 w-3" />Extranet
          </Link>
        </div>
      </div>

      <header className="bg-white py-4 px-6 flex items-center justify-between relative z-50 shadow-sm">
        <Link to="/" className="flex items-center">
          <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10" />
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          <Link to="/fitness" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Fitness</Link>
          <Link to="/racket" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Racket</Link>
          <Link to="/wellness" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Wellness</Link>
          <Link to="/ueber-uns" className="px-4 py-2 text-orange-500 font-medium">Über uns</Link>
          <Link to="/kontakt" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Kontakt</Link>
        </nav>
        <div className="flex items-center gap-4">
          <a href="https://www.courtsonline.ch/?a=Ng==" target="_blank" rel="noopener noreferrer" className="hidden sm:block bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-bold text-sm">PLATZ BUCHEN</a>
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden p-2 hover:bg-gray-100 rounded">
            {menuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>
      </header>

      {menuOpen && (
        <div className="fixed inset-0 bg-white z-40 pt-20 lg:hidden">
          <nav className="flex flex-col py-4">
            <Link to="/fitness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold border-b">Fitness</Link>
            <Link to="/racket" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold border-b">Racket</Link>
            <Link to="/wellness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold border-b">Wellness</Link>
            <Link to="/ueber-uns" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-orange-500 border-b">Über uns</Link>
            <Link to="/kontakt" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold border-b">Kontakt</Link>
            <Link to="/" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold">← Zurück</Link>
          </nav>
        </div>
      )}

      <section className="py-20 bg-[#1e3a5f] text-center">
        <h1 className="text-6xl md:text-8xl font-black text-orange-500">Für di do</h1>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-black text-gray-900 mb-4">Öffnungszeiten</h2>
            <p className="text-gray-600">Für Fitness-Mitglieder und Sportgäste 365 Tage offen.</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Fitness</h3>
              <p className="text-gray-700">Mo-Fr: 06:00 – 23:00</p>
              <p className="text-gray-700">Sa/So: 06:00 – 20:00</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Racketsport</h3>
              <p className="text-gray-700">Mo-Fr: 06:00 – 23:00</p>
              <p className="text-gray-700">Sa/So: 06:00 – 20:00</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Sauna</h3>
              <p className="text-gray-700">Mo-Fr: 13:30 – 21:30</p>
              <p className="text-gray-700">Sa/So: 09:30 – 15:45</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Betreute Zeiten</h3>
              <p className="text-gray-700">Mo-Fr: 08:30 – 21:30</p>
              <p className="text-gray-700">Sa/So: 08:30 – 16:00</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-black text-gray-900 text-center mb-12">Warum Vitalis ?</h2>
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl text-white">🏋️</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Modern</h3>
              <p className="text-gray-600 text-sm">Modernste Geräte von Technogym</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl text-white">❤️</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Herzlich</h3>
              <p className="text-gray-600 text-sm">Persönliche Betreuung</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl text-white">🎯</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Kompetent</h3>
              <p className="text-gray-600 text-sm">Fachkompetente Unterstützung</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl text-white">👨‍👩‍👧‍👦</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Familiär</h3>
              <p className="text-gray-600 text-sm">Familiär geführter Betrieb</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-black text-gray-900 text-center mb-12">Unser Team</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm">
              <div className="aspect-square bg-gray-200">
                <img src="https://images.unsplash.com/photo-1594381898411-846e7d193883?w=400&q=80" alt="Daniela" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900">Daniela Casanova</h3>
                <p className="text-orange-500 font-medium">Geschäftsführung</p>
              </div>
            </div>
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm">
              <div className="aspect-square bg-gray-200">
                <img src="https://images.unsplash.com/photo-1567013127542-490d757e51fc?w=400&q=80" alt="Dominic" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900">Dominic Schüler</h3>
                <p className="text-orange-500 font-medium">Centerleiter</p>
              </div>
            </div>
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm">
              <div className="aspect-square bg-gray-200">
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80" alt="Myriam" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900">Myriam Grob-Casanova</h3>
                <p className="text-orange-500 font-medium">Mitarbeiterin</p>
              </div>
            </div>
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm">
              <div className="aspect-square bg-gray-200">
                <img src="https://images.unsplash.com/photo-1548690312-e3b507d8c110?w=400&q=80" alt="Carmen" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900">Carmen Gmünder</h3>
                <p className="text-orange-500 font-medium">Mitarbeiterin</p>
              </div>
            </div>
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm">
              <div className="aspect-square bg-gray-200">
                <img src="https://images.unsplash.com/photo-1550259979-ed79b48d2a30?w=400&q=80" alt="Vanessa" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900">Vanessa Hobi</h3>
                <p className="text-orange-500 font-medium">Personal Trainerin</p>
              </div>
            </div>
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm">
              <div className="aspect-square bg-gray-200">
                <img src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&q=80" alt="Tom" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900">Tom Graf</h3>
                <p className="text-orange-500 font-medium">Fitness-Instruktor</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-orange-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">Jetzt Beratung vereinbaren</h2>
          <a href="https://vitalis-sports.ch/beratungsgespraech/" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-orange-500 hover:bg-gray-100 px-10 py-4 rounded font-bold text-lg">
            Termin finden
          </a>
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10 mb-4 brightness-0 invert opacity-70" />
              <p className="text-sm">Dein familiäres Fitness- und Sportcenter im Rheintal.</p>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Angebot</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/fitness" className="hover:text-white">Fitness</Link></li>
                <li><Link to="/racket" className="hover:text-white">Racket</Link></li>
                <li><Link to="/wellness" className="hover:text-white">Wellness</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Kontakt</h4>
              <ul className="space-y-2 text-sm">
                <li>Rorschacherstrasse 43</li>
                <li>9450 Lüchingen/Altstätten</li>
                <li>+41 71 755 50 66</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Extranet</h4>
              <Link to="/login" className="inline-flex items-center gap-2 bg-orange-500 text-white px-4 py-2 rounded text-sm">
                <Users className="h-4 w-4" />Anmelden
              </Link>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-sm">
            <p>© 2026 Vitalis Sports</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
